import useSWR from "swr";
import { useSWRConfig } from "swr";
import { IGetEventTicketsResponse } from "pages/api/event-tickets";

const fetcher = (url: string) => fetch(url).then((res) => res.json());

export function useGetRemainingTickets(
  eventId: string,
  options?: { refreshInterval: number }
): {
  ticketData: IGetEventTicketsResponse;
  isLoading: boolean;
  isError: any;
} {
  const { data, error } = useSWR(
    `/api/event-tickets?event_id=${eventId}`,
    fetcher,
    options
  );

  return {
    ticketData: !!data && !data["error"] && { ...data },
    isLoading: !data && !error,
    isError: error || (data && data["error"]),
  };
}
